module.exports = ".footerContentsection {\r\n    background-color: #fff;\r\n    margin-left: 20px;\r\n    font-size: 14px;\r\n    padding: 15px;\r\n}"